<template>
  <div class="container-list">
    <div class="flex">
      <!-- <unitList @select="getUnit" @getFirst="getOne"></unitList> -->
      <unitList v-show="!($store.state.user.userInfo.natureId == 2)" @getFirst="getOne" @select="getUnit"></unitList>
      <div class="flex1">
        <div class="common-page common-head">
          <div class="common-page common-head-title">
            <i class="icon-tr--detailed" style="padding-right: 5px"></i>
            人员信息
          </div>
        </div>
        <div class="common-page common-body">
          <div class="common-page common-tool-bar" style="justify-content: space-between">
            <div class="flex">
              <div>
                <router-link v-hasPermi="['plan:person:group']" class="ml20" to="/plan/notice">
                  <el-button icon="el-icon-office-building" type="success">应急组织机构</el-button>
                </router-link>
                <router-link v-hasPermi="['drillplan:planJianzhu:planArea']" class="ml20" to="/plan/build-device">
                  <el-button icon="el-icon-timer" type="success">建筑分区信息</el-button>
                </router-link>
                <router-link v-hasPermi="['drillplan:planUser:addAndUpdate']" class="ml20" to="/plan/mumber">
                  <el-button icon="el-icon-user" type="success">新增人员信息</el-button>
                </router-link>
              </div>
            </div>
            <div class="flex">
              <div class="ml20">
                <el-button v-hasPermi="['drillplan:planUser:import']" icon="el-icon-upload" type="primary" @click="importPersonnel()" >导入</el-button>
              <el-button  icon="el-icon-search" type="primary" @click="goSearch">查询</el-button>
              <!-- <el-button  icon="el-icon-refresh" type="primary" @click="cancle">重置</el-button> -->
              <el-button @click="cancle" type="primary" icon="el-icon-refresh-right">重置</el-button>
              </div>
              
            </div>
          </div>
          <div class="common-page common-list">
            <el-table :data="list" class="">
              <el-table-column align="center" label="序号" prop="num"></el-table-column>
              <el-table-column align="center" label="固定职责" prop="fixedResp"></el-table-column>
              <el-table-column align="center" label="姓名" prop="name"></el-table-column>
              <el-table-column align="center" label="性别" prop="name">
                <template slot-scope="scope">
                  {{ scope.row.sex == 1 ? "男" : "女" }}
                </template>
              </el-table-column>
              <el-table-column align="center" label="电话" prop="phone"></el-table-column>
              <el-table-column align="center" label="一级分区" prop="tower"></el-table-column>
              <el-table-column align="center" label="二级分区" prop="tier"></el-table-column>
              <el-table-column align="center" label="所在部门" prop="department"></el-table-column>
              <el-table-column align="center" fixed="right" label="操作" width="200px">
                <template slot-scope="scope">
                  <router-link
                      v-hasPermi="['drillplan:planUser:query']"
                      :to="{
											path: '/plan/mumber',
											query: { id: scope.row.id },
										}"
                  >
                    <el-button size="mini" type="warning">编辑</el-button>
                  </router-link>
                  <el-popconfirm
                      v-if="scope.row.c_states == 1"
                      v-hasPermi="['plan:person:remove']"
                      class="cursor"
                      title="确定禁用单位记录吗？"
                      @confirm="changeStatus(scope.row, 0)"
                      @onConfirm="changeStatus(scope.row, 0)"
                  >
                    <a slot="reference" class="red">
                      <el-button plain size="mini" type="danger">停用</el-button>
                    </a>
                  </el-popconfirm>
                  <el-popconfirm
                      v-if="scope.row.c_states == 0"
                      v-hasPermi="['plan:person:remove']"
                      class="cursor"
                      title="确定启用此单位吗？"
                      @confirm="changeStatus(scope.row, 1)"
                      @onConfirm="changeStatus(scope.row, 1)"
                  >
                    <a slot="reference">
                      <el-button plain size="mini" type="primary">开启</el-button>
                    </a>
                  </el-popconfirm>

                  <el-popconfirm
                      v-hasPermi="['drillplan:planUser:remove']"
                      class="cursor"
                      title="确定删除此项吗？"
                      @confirm="changeStatus(scope.row, 2)"
                      @onConfirm="changeStatus(scope.row, 2)"
                  >
                    <a slot="reference">
                      <el-button size="mini" type="danger">删除</el-button>
                    </a>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination
              :current-page.sync="params.pageNum"
              :page-size="params.pageSize || 10"
              :total="total"
              background
              layout="prev, pager, next"
              @current-change="pageChange"
          ></el-pagination>
        </div>
      </div>
    </div>

    <!-- 导入 -->
    <el-dialog :title="upload.title" :visible.sync="upload.open" append-to-body width="400px" >
      <el-upload
          ref="upload"
          :action="upload.url + '?updateSupport=' + upload.updateSupport"
          :auto-upload="false"
          :before-upload="beforeUpload"
          :data="{ companyNum: upload.companyNum }"
          :disabled="upload.isUploading"
          :headers="upload.headers"
          :limit="1"
          :on-progress="handleFileUploadProgress"
          :on-success="handleFileSuccess"
          accept=".xlsx, .xls"
          drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip text-center">
          <div slot="tip" class="el-upload__tip">
            <el-checkbox v-model="checked" @change="checkboxValue()"/>
            是否更新已经存在的用户数据
          </div>
          <span>仅允许导入xls、xlsx格式文件。</span>
          <el-link :underline="false" style="font-size: 12px; vertical-align: baseline" type="primary" @click="downTel()">下载模板</el-link>
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFileForm">确 定</el-button>
        <el-button @click="upload.open = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="true" :visible.sync="showDia" title="查询">
      <el-form ref="form" :model="form" label-width="110px">
        <el-form-item label="所在组织" prop="login_pass">
          <el-select v-model="form.organi">
            <el-option v-for="(item, index) in roles" :key="item.zuzhi_name" :label="item.zuzhi_name" :value="item.zuzhi_xuhao"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="一级分区" prop="user_phone">
          <el-select v-model="form.tower" filterable placeholder="请选择" @change="changetower">
            <el-option v-for="(item, index) in units" :key="item.tower" :label="item.tower" :value="item.tower" @change="changetower($event, index)"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级分区" prop="user_phone">
          <el-select v-model="form.tier" filterable placeholder="请选择">
            <el-option v-for="item in select2" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div class="center">
        <el-button size="small" type="primary" @click="searchSubmit">确定</el-button>
        <el-button plain size="small" type="info" @click="showDia = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :visible.sync="showDia1" title="下发预案短信">
      <div class="center">
        <el-button type="primary" @click="sendMessage()">下发短信</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import unitList from "@/components/unitList";
import {downLoadExcel} from "@/utils/download";

export default {
  components: {unitList},
  data() {
    return {
      checked:false,
      cpNum: "",
      searchForm: this.$getForm("weibaoProSearch"),
      list: [],
      groups: [],
      params: {
        pageNum: 1,
        pageSize: 10,
        organi: "",
        tower: "",
        tier: "",
        companyNum: this.cpNum || this.$store.state.user.company.c_company_num,
      },
      roles: [],
      units: [],
      select2: [],
      messForm: {
        thing: "",
        dong: "",
        lou: "",
        zuzhi: "",
      },
      form: {
        tower: "", // bulid
        tier: "", //  floor
        organi: 1, // first response
      },
      people: [],
      total: 0, // sum
      showDia: false, // search
      checkAll: false, // selectAll
      showDia1: false, // send message
      // searchForm: this.$getForm("planPerson"),
      editData: {},
      remoteFuncs: {},

      // 上传
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: "人员导入",
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: {Authorization: "Bearer " + this.$local.get("token")},
        // 上传的地址
        url: this.$config.apiUrl + "/drillplan/planUser/importPlanPersonnelData",
        // 编号
        companyNum: "",
      },
    };
  },
  created() {
    this.$post("/drill/grouplist").then((res) => {
      this.roles = res.data;
      // this.units = res.data.company;
    });
    // 区域
  },

  beforeRouteEnter(to, from, next) {
    console.log(from);
    next((vm) => {
      if (from.name === "/plan/mumber") {
        vm.getList();
      }
    });
  },
  methods: {
    checkboxValue(){
      log(this.checked,11111)
      if (this.checked) {
        this.upload.updateSupport=1
      }else{
        this.upload.updateSupport=0
      }
      
    },
    getOne(v) {
      this.cpNum = v;
      this.upload.companyNum = v;
    },
    getUnit(v) {
      this.cpNum = v;
      this.upload.companyNum = v;
    },
    handleCheckAllChange(val) {
      var arr = [];
      this.roles.map((item) => {
        arr.push(item.zuzhi_xuhao);
      });
      this.people = val ? arr : [];
    },
    sendMessage() {
      this.messForm.zuzhi = this.people.join(",");
      this.$post(url, this.messForm).then((res) => {
        this.$message({message: res.msg,type: "success", duration: 700,});
      });
      this.messForm = {thing: "", dong: "", lou: "", zuzhi: ""};
      this.showDia1 = false;
      this.people = [];
    },

    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.roles.length;
    },
    goSearch() {
      this.resetSearch();
      this.showDia = true;
      let companyNum = this.params.companyNum;
      this.$get(`/drillplan/planJianzhu/planArea/${companyNum}`).then((res) => {

        this.units = res.data;
      });
    },
    changetower(val, index) {
      this.units.map((item, index) => {
        if (item.tower === val) {
          this.select2 = item.tierList;
        }
      });
    },
    changeStatus(it) {
      this.$remove(`/drillplan/planUser/${it.id}`).then((res) => {
        log(res, "del list");
        this.$message({message: res.msg,type: "success", duration: 700,});
        this.getList();
      });
    },
    cancle() {
      this.params.pageNum = 1;
      this.select2=[]
      this.resetSearch();
      this.getList();
    },

    // make erweima

    getList() {
      this.$post("/drillplan/planUser/list", this.params).then((res) => {
        this.list = res.rows;
        this.total = res.total;
      });
    },

    pageChange(val) {
      this.params.pageNum = val;
      this.getList();
    },
    searchSubmit() {
      this.params = {...this.params, ...this.form};
      this.getList();
      this.showDia = false;
    },

    resetSearch() {
      this.form = {
        tower: "", // build
        tier: "", // floor
        organi: "", // first respons
      };
      this.params = {...this.params, ...this.form};
    },
    // 人员导入
    importPersonnel() {
      // console.log(1111);
      this.checked=false
      this.upload.updateSupport=0
      this.upload.open = true;
    },
    // 文件上传中处理
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
    // 文件上传成功处理
    handleFileSuccess(response, file, fileList) {
      console.log(response, "response");
      this.upload.open = false;
      this.upload.isUploading = false;
      this.$refs.upload.clearFiles();
      response.msg=`<div style="height:400px;overflow:scroll;">${response.msg}</div>`
      this.$alert(response.msg, "导入结果", {dangerouslyUseHTMLString: true});
      this.getList();
    },
    // 文件上传前的操作
    beforeUpload(file) {
      console.log(file);
      this.loading = true;
    },
    // 提交上传文件
    submitFileForm() {
      console.log(this.$refs.upload, "this.$refs.upload");

      this.$refs.upload.submit();
    },
    //下载模板操作
    downTel() {
      // log(1111111111)
      downLoadExcel("/drillplan/planUser/downloadPlanPersonnelTemplate");
    },
  },


  watch: {
    cpNum() {
      this.params.companyNum = this.cpNum;
      this.params.pageNum = 1;
      this.getList();
    },
    showDia1(val) {
      if (val) {
        this.checkAll = val;
        this.handleCheckAllChange(val);
      }
    },
  },
};

</script>

<style scoped>
.el-dialog .el-dialog__body {
  padding: 0 !important;
}
</style>
